import { defineComponent as n, computed as i, useCssModule as c, createElementBlock as l, openBlock as u, normalizeStyle as m, normalizeClass as p, unref as g } from "vue";
import { CdrRadiusSoft as f, CdrRadiusSofter as C, CdrRadiusRound as y } from "@rei/cdr-tokens";
const h = ["src", "alt", "srcset", "sizes", "loading", "decoding", "fetchpriority"], z = "cdr-image", S = /* @__PURE__ */ n({
  name: "CdrImg",
  __name: "CdrImg",
  props: {
    src: {},
    alt: {
      default: ""
    },
    srcset: {},
    sizes: {},
    fit: {},
    position: {},
    radius: {},
    ratio: {},
    loading: {},
    decoding: {},
    fetchpriority: {}
  },
  setup(o) {
    const e = o, r = /* @__PURE__ */ new Map([["soft", f], ["softer", C], ["round", y]]), t = i(() => r.get(e.radius) ? `${r.get(e.radius)}rem` : e.radius), a = i(() => ({
      "--cdr-img-aspect-ratio": e.ratio,
      "--cdr-img-object-position": e.position,
      "--cdr-img-object-fit": e.fit,
      "--cdr-img-border-radius": t.value
    })), d = c();
    return (s, R) => (u(), l("img", {
      class: p(g(d)[z]),
      style: m(a.value),
      src: s.src,
      alt: s.alt,
      srcset: s.srcset,
      sizes: s.sizes,
      loading: s.loading,
      decoding: s.decoding,
      fetchpriority: s.fetchpriority
    }, null, 14, h));
  }
});
export {
  S as default
};
